/** Role names shared across every product module. */
export const MODULE_ROLES = ["owner", "collaborator", "viewer"];
/**
 * Provenance of a module-library item relative to the current actor.
 *
 * `created` means the immutable creator is the actor. `shared` means the actor
 * can see the item through membership/access granted by somebody else. Keeping
 * this vocabulary shared makes the Solve, VSM, and Hoshin list APIs expose the
 * same filter contract.
 */
export const MODULE_ACCESS_ORIGINS = ["created", "shared"];
//# sourceMappingURL=module-base.js.map